import React from 'react'
import { IconContext } from 'react-icons'
import { AiOutlineFileAdd } from 'react-icons/ai'
import { Link } from 'react-router-dom'

function Home() {
    return (
        <div className="homepage">
            <IconContext.Provider value={{ color: '#060b26', size: 75}}>
                <h1>Welcome to Rayy-Docs</h1>
                <Link to='/'>                
                    <div className="new-doc">
                        <div className="new-doc-contents">                    
                        <AiOutlineFileAdd />
                        <h3>Create a New Document</h3>
                        </div>
                    </div>
                </Link>
            </IconContext.Provider>
        </div>
    )
}

export default Home
